import { Component, OnInit, HostListener, ViewEncapsulation, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { Breakpoints } from '@angular/cdk/layout';
import { SharedDataService } from 'src/services/shared-data.service';
import { Instrument } from 'src/models/question.model';
import { Launch } from 'src/models/launch.model';
import { Organization } from 'src/models/organization.model';
import { MatDialog } from '@angular/material/dialog';
import { MaterialModule } from '../material.module';
import { LaunchStatus } from 'src/models/app-enums.model';
import { SanitizeHtmlPipe } from "../questions/filter-section.pipe";
import { QuestionnaireResponse } from 'src/models/questionnaire-response.model';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, MaterialModule, SanitizeHtmlPipe, SharedModule]
})

export class HeaderComponent implements OnInit {

  constructor(
    @Inject(DOCUMENT) private document: Document, private responsive: BreakpointObserver,
  private sharedDataService: SharedDataService, public dialog: MatDialog, private router: Router) { }

  isPhonePortrait = false;
  oInstrument!: Instrument;
  oLaunch!: Launch;
  oOrganization: Organization | undefined;
  questionnaireResponse!: QuestionnaireResponse;
  culture: string | undefined;
  questionnaireProgress: number = 1;
  path: string | undefined;
  isPreviewMode: boolean = false;
  patientTerm: string | undefined = ""; //patient term at Orglevel for future implementation in Introduction, Help, Terms and Condition text
  languagesSelected: string[] = [];
  showProgressInHeader: boolean = false;
  launchClosed = LaunchStatus.LaunchClosed;
  instrumentType: string = 'gws';

  @HostListener("window:scroll", ['$event'])
  onWindowScroll()
  {
    const offset = this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;
    const limit = this.isPhonePortrait ? 95 : 40;
    if (offset > limit)
    {
      this.showProgressInHeader = true;
    } else
    {
      this.showProgressInHeader = false;
    }
  }

  ngOnInit(): void
  {

    this.responsive.observe([Breakpoints.Small, Breakpoints.HandsetPortrait])
      .subscribe(result =>
      {
        this.isPhonePortrait = false;
        if (result.matches)
        {
          this.isPhonePortrait = true;
        }
      });

    this.culture = $localize.locale;

    // fetch instruments
    this.sharedDataService.instrument$.subscribe(instrument => {
      if(instrument) {
        this.oInstrument = instrument;
        this.instrumentType = instrument.instrumentsType.toLowerCase();
      }
    })

    // fetch launch
    this.sharedDataService.launch$.subscribe(launch => {
      if(launch) {
        this.oLaunch = launch
        this.languagesSelected = launch.languageSelected!.split(",");
      }
    })

    // preview mode
    this.sharedDataService.previewMode$.subscribe((previewMode) => {
      this.isPreviewMode = previewMode
    })

    // fetch questionnaireResponse
    this.sharedDataService.questionnaireResponse$.subscribe((questionnaireResponse) => {
      if (questionnaireResponse) {
        this.questionnaireResponse = questionnaireResponse
      }
    })
    
    this.sharedDataService.questionnaireProgress.subscribe((sharedDataQuestionnaireProgress: number) => {
      this.questionnaireProgress = Number(sharedDataQuestionnaireProgress);
    });

  }

  localesList = [
    { code: 'en-ca', label: 'English' },
    { code: 'fr-ca', label: 'Français' },
    { code: 'es-ec', label: 'Español' },
    { code: 'fr-be', label: 'Français (Belgique)' },
    { code: 'it-it', label: 'Italiano' },
    { code: 'nl-nl', label: 'Nederlands' }
  ];

  public toPercentageNumber(value: number): number
  {
    return this.questionnaireProgress * 100;
  }

  openRespondentFAQDoc(type: string) {
    type LocalizedText = { 'en-ca': string; 'fr-ca': string; };
    const faqData: Record<string, LocalizedText> = {
      'GWS': {
        'en-ca': "https://www3.accreditation.ca/OrgPortal/documents/Terms/surveyui/HSO-Global-Workforce-Survey-Creation-and-Management-Guide-EN-CA.pdf",
        'fr-ca': "https://www3.accreditation.ca/OrgPortal/documents/Terms/surveyui/HSO-Global-Workforce-Survey-Creation-and-Management-Guide-FR-CA.pdf",
      } as LocalizedText,
      'GBA': {
        'en-ca': "https://www3.accreditation.ca/OrgPortal/documents/Terms/surveyui/HSO-Governing-Body-Assessment-Guide-EN-CA.pdf",
        'fr-ca': "https://www3.accreditation.ca/OrgPortal/documents/Terms/surveyui/HSO-Governing-Body-Assessment-Guide-FR-CA.pdf",
      } as LocalizedText,
      // TODO - per requirement, use the same files for GBA until GBA-QC FAQ is prepared
      'GBA-QC': {
        'en-ca': "https://www3.accreditation.ca/OrgPortal/documents/Terms/surveyui/HSO-Governing-Body-Assessment-Guide-EN-CA.pdf",
        'fr-ca': "https://www3.accreditation.ca/OrgPortal/documents/Terms/surveyui/HSO-Governing-Body-Assessment-Guide-FR-CA.pdf",
      } as LocalizedText,
    };
    const selectedLocaleId = this.culture?.toLocaleLowerCase();
    switch (selectedLocaleId) {
      case ('fr-ca'):
        window.open(faqData[type.toUpperCase()][selectedLocaleId], '_blank');
        break;
      case ('en-ca'):
      default:
        window.open(faqData[type.toUpperCase()]['en-ca'], '_blank');
        break;
    }
  }
}
